
const index = () => import('@/views/login/index.vue');
const login = () => import('@/views/login/login.vue');
const register = () => import('@/views/login/register.vue');
const forgotPhone = () => import('@/views/login/forgotPhone.vue');
export default [
    {
        path: '/',
        name: 'index',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '',
        },
        components: {
            default: index,
        }
    },
    {
        path: '/index',
        name: 'index',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '',
        },
        components: {
            default: index,
        }
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '',
        },
        components: {
            default: login,
        }
    },{
        path: '/register',
        name: 'register',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '',
        },
        components: {
            default: register,
        }
    },{
        path: '/forgotPhone',
        name: 'forgotPhone',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '',
        },
        components: {
            default: forgotPhone,
        }
    }
];
